import { Color } from 'constants/assets'
import React from 'react'
import ReactLoading from 'react-loading'
import classnames from 'classnames'
import styles from './TotalCount.module.sass'

/**
 * @interface Props Input properties
 */
export interface Props {
  /** Total count number or string displayed on the box */
  totalCount: string | number | null
  /** Whether the parent item is active or not */
  isActive?: boolean
  /** Additional classes for the total count text */
  className?: string
  /** Renders spans instead of divs, for a count inside a button */
  isInline?: boolean
}

/**
 * @component TotalCount used on dashboard filters to show number
 * @example
 * <TotalCount
 *  totalCount="26"
 * />
 */
const TotalCount: React.FC<Props> = ({
  totalCount,
  isActive = false,
  className = '',
  isInline = false,
}) => {
  const Wrap = isInline ? 'span' : 'div'

  return (
    <Wrap className={styles.totalCountWrap}>
      <Wrap className={classnames(styles.totalCount, isActive ? styles.isActive : undefined)}>
        {typeof totalCount !== 'undefined' && totalCount !== null ?
          <span className={className}>{String(totalCount)}</span>
          :
          <ReactLoading color={Color.GRAY_TEXT} type="cylon" height="2rem" width="2rem" />
        }
      </Wrap>
    </Wrap>
  )
}

export default TotalCount
